<app-web-navbar></app-web-navbar>

<div class="content-grow">
  <section class="pdp-page page-content">

    <!-- BREADCRUMB -->
    <div class="pdp-breadcrumb-bar">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <a routerLink="/" class="text-decoration-none"><i class="bi bi-house-door me-1"></i>Home</a>
            </li>
            <li class="breadcrumb-item active fw-semibold">
              {{ product?.categoryDetails?.categoryName || 'Category' }}
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="pdp-content-area">
      <div class="container">
        <div class="row g-4 g-lg-5">

          <!-- ================= LEFT : IMAGE GALLERY ================= -->
          <div class="col-12 col-lg-6">
            <div class="pdp-gallery-section">

              <!-- MAIN IMAGE SLIDER -->
              <div class="pdp-main-image-wrapper" *ngIf="sliderImages?.length">
                <div class="pdp-image-actions">
                  <button type="button" class="pdp-img-action-btn" title="Download all images"
                    (click)="downloadAllThumbnails()">
                    <i class="bi bi-download"></i>
                  </button>
                </div>

                <button class="slider-nav left" (click)="prevImage()">
                  <i class="bi bi-chevron-left"></i>
                </button>

                <img [src]="getImageById(sliderImages[currentIndex]?.imageDetailsId)" class="pdp-main-image"
                  (error)="onImageError($event)" />

                <button class="slider-nav right" (click)="nextImage()">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>

              <div class="pdp-slider-dots" *ngIf="sliderImages?.length > 1">

                <span *ngFor="let img of sliderImages; let i = index" class="dot" [class.active]="i === currentIndex"
                  (click)="goToImage(i)"></span>

              </div>

              <!-- THUMBNAILS (PRIMARY IMAGES ONLY) -->
              <div class="pdp-thumb-strip">

                <!-- LEFT ARROW -->
                <button class="thumb-nav left" (click)="scrollThumbs('left')">
                  <i class="bi bi-chevron-left"></i>
                </button>

                <!-- THUMBNAILS -->
                <div #thumbContainer class="pdp-thumb-scroll">

                  <div *ngFor="let img of activeImages" class="pdp-thumb-item"
                    [class.active]="img.variantId === selectedVariantId" (click)="changeVariantByPrimary(img)">

                    <img [src]="getImageById(img.imageDetailsId)" />

                  </div>

                </div>

                <!-- RIGHT ARROW -->
                <button class="thumb-nav right" (click)="scrollThumbs('right')">
                  <i class="bi bi-chevron-right"></i>
                </button>

              </div>

            </div>
          </div>

          <!-- ================= RIGHT : DETAILS ================= -->
          <div class="col-12 col-lg-6">
            <div class="pdp-info-section">
              <!-- ACTION BUTTONS -->
              <div class="pdp-cta-group">
                <button type="button" class="pdp-cta-primary" [disabled]="!selectedVariantId"
                  (click)="verifyUserDetails()">
                  <i class="bi bi-bag-plus me-2"></i> ADD TO CART
                </button>
              </div>
              <!-- CATEGORY + AVAILABILITY -->
              <div class="pdp-top-badges">
                <span class="pdp-cat-badge" *ngIf="product?.categoryDetails?.categoryName">
                  {{ product?.categoryDetails?.categoryName }}
                </span>
                <span class="pdp-stock-badge in-stock">
                  <i class="bi bi-circle-fill me-1"></i> In Stock
                </span>
              </div>

              <!-- PRODUCT NAME -->
              <h1 class="pdp-title">{{ product?.productName }}</h1>

              <!-- BARCODE CODE -->
              <p class="text-md text-danger">
                <b>Code</b>: {{this.barCodeNumber}}
              </p>

              <!-- DIVIDER -->
              <hr class="pdp-divider">

              <!-- PRICE BLOCK -->
              <div class="pdp-price-block">
                <div class="pdp-price-inner">
                  <span class="pdp-price-main">₹{{ tselectedPrice }}</span>
                  <span class="pdp-price-mrp" *ngIf="tselectedOfferPrice && tselectedOfferPrice > tselectedPrice">
                    MRP ₹{{ tselectedOfferPrice }}
                  </span>
                  <span class="pdp-price-off" *ngIf="tselectedOfferPrice && tselectedOfferPrice > tselectedPrice">
                    {{ ((tselectedOfferPrice - tselectedPrice) / tselectedOfferPrice * 100) | number:'1.0-0' }}% OFF
                  </span>
                </div>
                <span class="pdp-tax-line">Inclusive of all taxes</span>
              </div>

              <!-- VIDEO CARD -->
              <a [href]="product?.youtubeLink" target="_blank" rel="noopener" class="pdp-video-strip"
                *ngIf="product?.youtubeLink">
                <div class="pdp-video-play-btn">
                  <i class="bi bi-play-fill"></i>
                </div>
                <div class="pdp-video-text">
                  <span class="pdp-video-title">Watch Product Video</span>
                  <span class="pdp-video-sub">See design, quality & styling tips</span>
                </div>
                <i class="bi bi-box-arrow-up-right pdp-video-arrow"></i>
              </a>

              <!-- SIZE SELECTOR (NORMAL PRODUCT) -->
              <div class="pdp-option-group" *ngIf="!isBulkProduct">

                <label class="pdp-option-label">SELECT SIZE</label>

                <div class="pdp-size-grid">

                  <button *ngFor="let s of sizeList" class="pdp-size-btn" [class.selected]="s === selectedSizeValue"
                    (click)="selectSize(s)">

                    {{ s }}

                  </button>

                </div>

              </div>

              <!-- BULK LABEL -->
              <div *ngIf="isBulkProduct" class="pdp-bulk-notice">
                <i class="bi bi-images me-2"></i> Tap on a design from the gallery to select
              </div>

              <!-- DESCRIPTION -->
              <div class="pdp-desc-block" *ngIf="product?.description">
                <label class="pdp-option-label">PRODUCT DETAILS</label>
                <div [innerHTML]="product?.description" class="pdp-desc-body"></div>
              </div>


              <!-- ================= SIZE (ONLY NORMAL PRODUCT) ================= -->
              <div class="mb-4" *ngIf="!isBulkProduct">

                <!-- <h6 class="fw-bold">Size</h6>

                <div class="d-flex gap-2 flex-wrap">

                  <button *ngFor="let v of product?.variants" class="btn"
                    [class.btn-dark]="v.productVariantId === selectedVariantId"
                    [class.btn-outline-dark]="v.productVariantId !== selectedVariantId" (click)="variantSelected(v)">

                    {{ v.size }}
                  </button>
                </div> -->

                <!-- HIGHLIGHTS -->
                <div class="pdp-highlights">
                  <div class="pdp-highlight-item">
                    <div class="pdp-highlight-icon genuine">
                      <i class="bi bi-patch-check"></i>
                    </div>
                    <div class="pdp-highlight-text">
                      <strong>100% Genuine</strong>
                      <span>Authentic products</span>
                    </div>
                  </div>
                  <div class="pdp-highlight-item">
                    <div class="pdp-highlight-icon secure">
                      <i class="bi bi-shield-lock"></i>
                    </div>
                    <div class="pdp-highlight-text">
                      <strong>Secure Payment</strong>
                      <span>Safe checkout</span>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-web-footer></app-web-footer>
</div>



<div class="modal-backdrop" *ngIf="isLoginModalOpen"></div>
<div class="modal-wrapper" *ngIf="isLoginModalOpen" role="dialog" aria-modal="true">
  <div class="modal-content p-4 rounded shadow-lg">

    <!-- Header -->
    <div class="modal-header d-flex justify-content-between align-items-center mb-3">
      <h5 class="modal-title">Login</h5>
      <button type="button" class="btn-close" (click)="closeLoginModal()"></button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Step 1: Email -->
      <div *ngIf="loginStep === 'email'">
        <label>Email</label>
        <input type="email" class="form-control mb-1" [(ngModel)]="loginEmail" placeholder="Enter your email">
        <div class="text-danger mb-2" *ngIf="loginEmail && !isValidEmail(loginEmail)">
          Invalid email format
        </div>
        <button class="btn btn-primary w-100" [disabled]="!loginEmail || !isValidEmail(loginEmail)"
          (click)="loginSendOtpApi()">
          Send OTP
        </button>
      </div>

      <!-- Step 2: OTP -->
      <div *ngIf="loginStep === 'otp'">
        <label>Enter OTP</label>
        <input type="text" maxlength="4" class="form-control mb-1" [(ngModel)]="loginOtp" (input)="checkLoginOtp()"
          placeholder="XXXX">
        <div class="text-danger mb-2" *ngIf="loginOtp && loginOtp.length < 4">
          OTP must be 4 digits
        </div>
        <button class="btn btn-primary w-100" [disabled]="!isLoginOtpValid" (click)="loginVerifyOtpApi()">
          Verify OTP
        </button>
      </div>

      <div *ngIf="loginError" class="text-danger mt-2">{{ loginError }}</div>
      <p class="mt-3 text-center">New User? <span class="text-primary" style="cursor:pointer;"
          (click)="switchToRegister()">Register</span></p>
    </div>
  </div>
</div>

<!-- ===== REGISTRATION MODAL ===== -->
<div class="modal-backdrop" *ngIf="isRegisterModalOpen"></div>
<div class="modal-wrapper" *ngIf="isRegisterModalOpen" role="dialog" aria-modal="true">
  <div class="modal-content p-4 rounded shadow-lg">

    <!-- Header -->
    <div class="modal-header d-flex justify-content-between align-items-center mb-3">
      <h5 class="modal-title">Register</h5>
      <button type="button" class="btn-close" (click)="closeRegisterModal()"></button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- Step 1: Email -->
      <div *ngIf="registerStep === 'email'">
        <label>Email</label>
        <input type="email" class="form-control mb-1" [(ngModel)]="registerEmail" placeholder="Enter your email">
        <div class="text-danger mb-2" *ngIf="registerEmail && !isValidEmail(registerEmail)">
          Invalid email format
        </div>
        <button class="btn btn-success w-100" [disabled]="!registerEmail || !isValidEmail(registerEmail)"
          (click)="registrationSendOtpApi()">
          Send OTP
        </button>
      </div>

      <!-- Step 2: OTP -->
      <div *ngIf="registerStep === 'otp'">
        <label>Enter OTP</label>
        <input type="text" maxlength="4" class="form-control mb-1" [(ngModel)]="registerOtp"
          (input)="checkRegisterOtp()" placeholder="XXXX">
        <div class="text-danger mb-2" *ngIf="registerOtp && registerOtp.length < 4">
          OTP must be 4 digits
        </div>
        <button class="btn btn-success w-100" [disabled]="!isRegisterOtpValid" (click)="registrationVerifyOtpApi()">
          Verify OTP
        </button>
      </div>

      <!-- Step 3: Details -->
      <div *ngIf="registerStep === 'details'">
        <label>First Name</label>
        <input type="text" class="form-control mb-1" [(ngModel)]="firstName" placeholder="First Name">
        <div class="text-danger mb-2" *ngIf="firstName && firstName.length < 2">
          First name must be at least 2 characters
        </div>

        <label>Phone Number</label>
        <input type="text" class="form-control mb-1" [(ngModel)]="phoneNumber" placeholder="Phone Number">
        <div class="text-danger mb-2" *ngIf="phoneNumber && !isValidPhone(phoneNumber)">
          Invalid phone number
        </div>

        <button class="btn btn-success w-100 mt-2"
          [disabled]="!firstName || firstName.length < 2 || !phoneNumber || !isValidPhone(phoneNumber)"
          (click)="completeRegistration()">
          Complete Registration
        </button>
      </div>

      <div *ngIf="registerError" class="text-danger mt-2">{{ registerError }}</div>
      <p class="mt-3 text-center">Already User? <span class="text-primary" style="cursor:pointer;"
          (click)="switchToLogin()">Login</span></p>
    </div>
  </div>
</div>